import styled from 'styled-components';
import { mediaQuery } from '~/styled';

export const WrapperDiv = styled.div`
  width: 316px;
  display: flex;
  flex-direction: column;
  padding: 12px 4px;
  gap: 16px;

  ${mediaQuery.down.l`
    width: calc(100% - 24px);
    border-radius: 16px;
    background-color: ${({ theme }) => theme.colors.surface};
    margin: 8px;
  `}
`;

export const AccountLinkDiv = styled.div`
  button {
    width: 100%;
    padding: 8px;
    height: 40px;
    gap: 16px;
  }
  button div {
    width: 100%;
    justify-content: initial;
  }
  button > div > span {
    width: 100%;
    text-align: start;
  }
`;
export const LogoutLinkDiv = styled.div`
  display: flex;
  justify-content: center;
`;
export const PreferencesDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
`;
export const PreferencesLabelDiv = styled.div`
  font-weight: 700;
  text-transform: uppercase;
  font-size: 16px;
`;
export const MeasurementUnitsWrapperDiv = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 16px;
  padding: 16px;
`;

export const MeasurementSystemLabelDiv = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 400;
  text-transform: none;
  line-height: 40px;
`;

export const MeasurementUnitsButtonsDiv = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 4px;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 16px;
`;
